<script>
import Plyr from 'plyr'
import Hls from 'hls.js'
import 'plyr/dist/plyr.css'

export default {

  props: {
    vodLink: {
      type: String
    },
  },
  data() {
    return {
      player: {},
      tempPlayer: null,
      options: {
        controls: ['play-large', 'play', 'mute', 'volume', 'settings', 'quality', 'fullscreen'],
        settings: ['quality'],
        keyboard: {focused: true, global: true},
        autoplay: true,
      },
      mainVideoLink: '',
      playerError: {}
    }
  },
  mounted() {
    // this.mainVideoLink = 'http://sample.vodobox.net/skate_wphantom_flex_4k/skate_phantom_flex_4k.m3u8'

    this.mainVideoLink = this.vodLink
    const video = this.$refs.PlyrVideoPlayer;

    const defaultOptions = this.options;

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(this.mainVideoLink);
      hls.on(Hls.Events.ERROR, function (event, data) {

        console.log('error', data.error)
        // this.playerError = data
      })
      hls.on(Hls.Events.MANIFEST_LOADED, function () {

        const playPause = document.querySelector(".plyr__controls__item.plyr__control");
        // Create a container div
        const containerDiv = document.createElement("div");
        containerDiv.className = "live"
        const redCircle = document.createElement("div");
        redCircle.className = "red-circle";

        // const liveText = document.createElement("span");
        // liveText.textContent = "LIVE";

        containerDiv.appendChild(redCircle);
        // containerDiv.appendChild(liveText);

        playPause.parentNode.insertBefore(containerDiv, playPause.nextSibling);

      });
      hls.on(Hls.Events.MANIFEST_PARSED, function (_event, _data) {
        const availableQualities = hls.levels.map((l) => l.height)
        availableQualities.unshift(0)

        defaultOptions.quality = {
          default: 0, //Default - AUTO
          options: availableQualities,
          forced: true,
          onChange: (newQuality) => {
            if (newQuality === 0) {
              window.hls.currentLevel = -1; //Enable AUTO quality if option.value = 0
            } else {
              window.hls.levels.forEach((level, levelIndex) => {
                if (level.height === newQuality) {
                  console.log("Found quality match with " + newQuality);
                  window.hls.currentLevel = levelIndex;
                }
              });
            }
          }
        }

        defaultOptions.i18n = {
          qualityLabel: {
            0: 'Auto',
          },
          quality: 'کیفیت',
        }
        hls.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
          var span = document.querySelector(".plyr__menu__container [data-plyr='quality'][value='0'] span")
          if (hls.autoLevelEnabled) {
            if(data.level === 3){
              hls.currentLevel = -1;
              span.innerHTML = `AUTO (${hls.levels[2].height}p)`
            }else{
              span.innerHTML = `AUTO (${hls.levels[data.level].height}p)`
            }
          } else {

            span.innerHTML = `AUTO`
          }
        })

        var mainPlayer = new Plyr(video, defaultOptions);

      });

      hls.attachMedia(video);
      window.hls = hls;
    } else {
      video.src = this.mainVideoLink;
      video.playsInline = true
      var mainPlayer = new Plyr(video, defaultOptions);
    }

  },

  computed: {
    tempPlayerM() {
      return this.tempPlayer
    }
  },
  methods: {},
}
</script>
<template>
  <div class="video-inner-plyr-hd" ref="videoPlayerSection">
    <video ref="PlyrVideoPlayer" ></video>
  </div>
</template>


<style lang="scss">
.video-inner-plyr-hd {
  // Style adjustments for Plyr player
  .plyr__control[data-plyr='fast-forward'],
  .plyr__control[data-plyr='rewind'] {
    img {
      width: 22px;
    }
  }
  .plyr--video{
    border-radius: 20px;
  }

  .plyr__volume input[type='range'] {
    direction: ltr;
  }

  .plyr.plyr--loading::after {
    content: '';
    position: absolute;
    width: 4rem;
    height: 4rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 8px solid transparent;
    border-top-color: #00b2ff;
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
  }

  @keyframes button-loading-spinner {
    from {
      transform: rotate(0turn);
    }

    to {
      transform: rotate(1turn);
    }
  }
}
</style>
